import { env } from '@/config/env'

/** Default DNS label for Platform Admin sessions (mirrors identity `PLATFORM_ADMIN_SUBDOMAIN`). */
export const DEFAULT_PLATFORM_ADMIN_SUBDOMAIN = 'admin' as const

/**
 * Reserved host label for Platform Admin (e.g. `admin.localhost:3000`).
 * Override with `VITE_PLATFORM_ADMIN_SUBDOMAIN` (must match identity `PLATFORM_ADMIN_SUBDOMAIN`).
 */
export function getPlatformAdminSubdomain(): string {
  const fromEnv = env.VITE_PLATFORM_ADMIN_SUBDOMAIN?.trim().toLowerCase()
  return fromEnv && fromEnv.length > 0
    ? fromEnv
    : DEFAULT_PLATFORM_ADMIN_SUBDOMAIN
}
